import React from 'react'
import type { RouteObject } from 'react-router-dom'
import JobOffers from 'spa/member/pages/JobOffers/Index'
import UserRegistrationFinish from 'spa/member/pages/User/Registration/Finish/Index'
import UserRegistrationWorkPreference from 'spa/member/pages/User/Registration/WorkPreference/Index'
import RecommendedJobOffers from 'spa/member/pages/RecommendedJobOffers'

const MemberRoutes: RouteObject[] = [
  // NOTE: メンバーページのルーティング
  // { path: '/dashboard', element: <MemberDashboard /> }, TODO: ダッシュボードのルーティングを追加する
  { path: '/job_offers', element: <JobOffers /> },
  // { path: '/job_offers/:id', element: <MemberJobOffer /> }, TODO: 案件詳細のルーティングを追加する
  { path: '/job_offers/:category_id/:id', element: <JobOffers /> },
  { path: '/job_offers/s/:skillId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId', element: <JobOffers /> },
  { path: '/job_offers/p/:prefectureId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId/s/:skillId', element: <JobOffers /> },
  { path: '/job_offers/s/:skillId/p/:prefectureId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId/p/:prefectureId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId/s/:skillId/p/:prefectureId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId/wd/:workingDayId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId/ws/:workStyleId', element: <JobOffers /> },
  { path: '/job_offers/o/:categoryId/a/:appealId', element: <JobOffers /> },
  { path: '/job_offers/s/:skillId/wd/:workingDayId', element: <JobOffers /> },
  { path: '/job_offers/s/:skillId/ws/:workStyleId', element: <JobOffers /> },
  { path: '/job_offers/s/:skillId/a/:appealId', element: <JobOffers /> },
  { path: '/user/registration/finish', element: <UserRegistrationFinish /> },
  { path: '/user/registration/work_preference', element: <UserRegistrationWorkPreference /> },
  { path: '/recommended_job_offers', element: <RecommendedJobOffers /> },
]

export default MemberRoutes
